import "../global.d.js";
import { validateTidalLicense } from "../base/index.js";
export * from "./smartLazy/smartLazy.js";
import * as applicationStorage from "./ApplicationStorage.js";
export * from "./isPlainObject.js";
validateTidalLicense();
export {
  applicationStorage
};
//# sourceMappingURL=index.js.map
